// extracted by mini-css-extract-plugin
export default {"body":"modalManagementLead_body__aUHq4","bold":"modalManagementLead_bold__KIB9X","link":"modalManagementLead_link__u12i5"};